import { render, staticRenderFns } from "./VolunteerFindMatch.vue?vue&type=template&id=5f8970c0"
import script from "./VolunteerFindMatch.vue?vue&type=script&lang=ts"
export * from "./VolunteerFindMatch.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerFindMatch.vue?vue&type=style&index=0&id=5f8970c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports